import React, { useState } from "react";

import ProgressBar from "../common/ProgressBar";

import t from "../../../../Common/utils/translation/translator";
import { tData } from "../../../../Common/utils/translation/dataUtils";

// MSC-1778: Component ComparatorLine must be commonalized
import ComparatorLine from "../../../../Retrofit/components/Devices/BundleComparator/ComparatorLine";

const AxisComparatorCarriageSection = ({ carriageNumber, compareDatas, ...props }) => {
  const [showCarriage, setCarriage] = useState(false);

  return (
    <div className="AxisComparatorCarriageSection" {...props}>
      <ComparatorLine
        data-testid={`axis-comparator-carriage-comparator-section-${carriageNumber + 1}`}
        compareData={compareDatas}
        title={t("cartesian.ui.axis_selection.carriage_n", { n: carriageNumber + 1 })}
        isSectionHeader
        opened={showCarriage}
        values={
          compareDatas.map((bundle) => bundle.carriageType?.typeOfCarriage) !== null
            ? compareDatas.map((bundle) => tData("axis_type", "carriage_type", bundle.carriageType?.typeOfCarriage))
            : "N/A"
        }
        onClick={() => {
          setCarriage(!showCarriage);
        }}
      />
      {showCarriage && (
        <>
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-mechanicalValues-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.mechanical_values")}
            values={compareDatas.map((bundle) => bundle.calculations?.mechanicalValues || 0)} // Pass mechanical values
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar
                  percentage={value}
                  data-testid="progress-bar-mechanicalValues"
                  reference={Math.round(value)}
                  unit="Nm"
                />
              </div>
            )}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumForceFys-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.force_fy")}
            values={compareDatas.map((bundle) => bundle.calculations?.forceFys[carriageNumber] || 0)}
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar
                  percentage={value}
                  data-testid="progress-bar-maximumForceFys"
                  reference={Math.round(value)}
                  unit="Nm"
                />
              </div>
            )}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumForceFzs-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.force_fz")}
            values={compareDatas.map((bundle) => bundle.calculations?.forceFzs[carriageNumber] || 0)}
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar
                  percentage={value}
                  data-testid="progress-bar-maximumForceFzs"
                  reference={Math.round(value)}
                  unit="Nm"
                />
              </div>
            )}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumTorqueMxs-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.torque_fx")}
            values={compareDatas.map((bundle) => bundle.calculations?.torqueMxs[carriageNumber] || 0)}
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar
                  percentage={value}
                  data-testid="progress-bar-maximumTorqueMxs"
                  reference={Math.round(value)}
                  unit="Nm"
                />
              </div>
            )}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumTorqueMys-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.torque_fy")}
            values={compareDatas.map((bundle) => bundle.calculations?.torqueMys[carriageNumber] || 0)}
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar
                  percentage={value}
                  data-testid="progress-bar-maximumTorqueMys"
                  reference={Math.round(value)}
                  unit="Nm"
                />
              </div>
            )}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumTorqueMzs-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.torque_fz")}
            values={compareDatas.map((bundle) => bundle.calculations?.torqueMzs[carriageNumber] || 0)}
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar
                  percentage={value}
                  data-testid="progress-bar-maximumTorqueMzs"
                  reference={Math.round(value)}
                  unit="Nm"
                />
              </div>
            )}
          />
        </>
      )}
    </div>
  );
};

export default AxisComparatorCarriageSection;
